var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "villas-carousel" },
    [
      _c(
        "swiper",
        {
          ref: "villas-carousel",
          attrs: { options: _vm.swiperOptions },
          on: { progress: _vm.updateSwiperEnd },
        },
        _vm._l(_vm.villas, function (villa, index) {
          return _c(
            "swiper-slide",
            { key: villa.id },
            [
              _c("villa-preview", {
                attrs: {
                  villa: villa,
                  length: _vm.villas.length,
                  position: index,
                },
              }),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      !_vm.isEnd
        ? _c(
            "button",
            {
              staticClass: "overlay-end",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.slideNext()
                },
              },
            },
            [_c("i", { staticClass: "icon-arrow-medium-right" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "nav-buttons" }, [
        _c(
          "button",
          {
            staticClass: "btn-prev",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.slidePrev()
              },
            },
          },
          [_c("i", { staticClass: "icon-arrow-medium-left" })]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-next",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.slideNext()
              },
            },
          },
          [_c("i", { staticClass: "icon-arrow-medium-right" })]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }